import type { ReactNode, SelectHTMLAttributes, InputHTMLAttributes, TextareaHTMLAttributes } from "react";

/** DS input styling, shared so a field never drifts. The focus ring is rule 7. */
const CONTROL =
  "w-full rounded-md border border-[var(--border-strong)] bg-[var(--bg)] px-3 text-sm text-[var(--text)] shadow-xs " +
  "placeholder:text-[var(--text-3)] hover:border-gray-400 focus:border-brand-500 focus-visible:focus-ring";

export function Field({ label, htmlFor, hint, span2, children }: { label: string; htmlFor: string; hint?: ReactNode; span2?: boolean; children: ReactNode }) {
  return (
    <div className={`flex flex-col gap-1.5 ${span2 ? "sm:col-span-2" : ""}`}>
      <label htmlFor={htmlFor} className="text-sm font-medium text-gray-800">
        {label}
        {hint && <span className="ml-1 font-normal text-[var(--text-2)]">{hint}</span>}
      </label>
      {children}
    </div>
  );
}

export function TextInput({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`${CONTROL} h-9 ${className ?? ""}`} />;
}

export function TextArea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} className={`${CONTROL} min-h-[88px] resize-y py-2 leading-5 ${className ?? ""}`} />;
}

export function Select({ children, className, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select {...props} className={`${CONTROL} h-9 appearance-none pr-8 ${className ?? ""}`}>
      {children}
    </select>
  );
}
